import React from "react"
import { createContext } from "@design-system/react-utils"
import { TabsContext } from "./types"

const [TabsProvider, useTabsContext] = createContext<TabsContext>({
  name: "TabsContext",
  errorMessage:
    "useTabsContext: `context` is undefined. Seems you forgot to wrap all tabs components within <Tabs />",
})

export { TabsProvider, useTabsContext }
